const footerGroups = [
  {
    title: '片单导航',
    links: [
      { label: '编辑精选', href: '#picks' },
      { label: '最新电影', href: '#latest' },
      { label: '电影排行榜', href: '#ranking' },
      { label: '高分佳作', href: '#toprated' },
    ],
  },
  {
    title: '发现更多',
    links: [
      { label: '冷门宝藏', href: '#gems' },
      { label: '专题合集', href: '#topics' },
      { label: '影迷热议', href: '#talk' },
      { label: '片单订阅', href: '#subscribe' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '收录说明', href: '#top' },
      { label: '片单更新节奏', href: '#picks' },
      { label: '影迷社区守则', href: '#talk' },
      { label: '意见反馈', href: '#subscribe' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-100 border-t border-primary-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-8 lg:gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">金桔影院</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              金桔影院以专题合集的方式整理好看的电影，把最新电影、热门影片与电影排行榜收进一份份可读片单，帮你在浏览前先有方向。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line'].map((icon) => (
                <a
                  key={icon}
                  href="#subscribe"
                  aria-label="金桔影院社交入口"
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-foreground-700 transition hover:text-primary-700 cursor-pointer"
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-950">{group.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-700 transition hover:text-primary-700 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">© 2026 金桔影院 · 专注好看的电影片单整理</p>
          <p className="text-xs text-foreground-600">本站内容为片单浏览推荐，页面展示信息仅作参考</p>
        </div>
      </div>
    </footer>
  );
}